const callbackEnglish = {
  processing: "Processing LinkedIn authorization...",
  verifying: "Verifying user information...",
  connecting: "Establishing secure connection to LinkedIn...",
  gettingProfile: "Retrieving profile information...",
  saving: "Safely storing your information...",
  connected: "LinkedIn account connected!",
  loadingSteps: {
    processing: "Processing authorization",
    connecting: "Establishing secure connection",
    profile: "Retrieving profile information",
    finishing: "Completing integration"
  },
  waitMessage: "Please wait while we complete the integration with your LinkedIn account...",
  error: {
    title: "An error occurred",
    solutions: {
      title: "Possible solutions:",
      clearCookies: "Clear browser cookies and cache",
      tryBrowser: "Try another browser (Chrome or Firefox recommended)",
      checkCookies: "Make sure you haven't blocked cookies from LinkedIn",
      useHttps: "Try accessing app.nuvik.io directly via HTTPS"
    },
    backButton: "Back to settings"
  },
  success: {
    title: "LinkedIn account connected!",
    message: "Your LinkedIn account is now connected to Nuvik.io.",
    redirect: "You will be redirected automatically..."
  }
};

export default callbackEnglish; 